export default __webpack_public_path__ + "static/media/slide-03.c036ef80.jpg";